var _defs, _path, _polygon, _polygon2, _polygon3, _path2, _path3, _rect, _path4, _rect2, _path5, _polygon4, _path6, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentPlanSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeaeb6;}.cls-2{fill:#363545;}.cls-3{fill:none;stroke:#be1e2d;stroke-miterlimit:10;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PresentPlan_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.09,27.14,27.94,32H32V24.24l-3.29.58A2,2,0,0,0,27.09,27.14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.13 29.15 0 29.88 0 32 3.63 32 4.13 29.15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.23 28.78 5.66 32 9 32 9 28.3 6.23 28.78"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.54 27.5 11 27.94 11 32 14.34 32 13.54 27.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,32h3.45l-.61-3.47a2,2,0,0,0-2.32-1.63l-1.38.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,0V19.29l2.37-.42a2,2,0,0,0,1.66-2V0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.03,
    width: 5.97,
    height: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,14.79a2,2,0,0,0,2.34,2L32,16.12V12H26Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.03,
    y: 6,
    width: 5.97,
    height: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0V6H12V0ZM9,4H3V2H9Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 8 0 21.76 4 21.05 4 10 8 10 8 20.35 12 19.64 12 8 0 8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,17.17V0H20V18.58a2,2,0,0,1-1.66,2L0,23.79v4.06l18.51-3.26a2,2,0,0,1,2.32,1.62l1,5.79h4.06l-1.14-6.48a2,2,0,0,1,1.62-2.32l5.61-1V18.15l-5.63,1A2,2,0,0,1,24,17.17Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -8.15,
    y: -58.62,
    width: 307.49,
    height: 95.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentPlanSvg);
export default __webpack_public_path__ + "static/media/PresentPlan_svg.e8f7386c2424de455e655752be3c4cf5.svg";
export { ForwardRef as ReactComponent };